module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 mt-8"
  }, [_c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto my-2"
  }, [_vm._v("\n          Cotizaciones Desarrollos (" + _vm._s(_vm.filteredDevelopments.length) + ")\n        ")])]), _vm._v(" "), ([1].includes(_vm.user.role)) ? _c('div', {
    staticClass: "col-span-6 sm:w-auto flex justify-end mb-4"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#development",
      "data-toggle": "modal"
    }
  }, [_vm._v("Agregar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 lg:col-span-12 xxl:col-span-12 grid grid-cols-6 gap-5"
  }, [_vm._l((_vm.status), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "hover:bg-theme-1 hover:text-white cursor-pointer border border-gray-400 px-2 py-1 w-full font-bold text-center rounded",
      class: item.name === _vm.filter.status ? 'bg-theme-1 text-white' : 'bg-white',
      on: {
        "click": function($event) {
          return _vm.setFilter(item.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "hover:bg-theme-1 hover:text-white cursor-pointer border border-gray-400 px-2 py-1 w-full font-bold text-center rounded",
    class: _vm.filter.status == '' ? 'bg-theme-1 text-white' : 'bg-white',
    on: {
      "click": function($event) {
        return _vm.setFilter(null)
      }
    }
  }, [_vm._v("\n          Todos\n        ")])], 2)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateDevelopment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Titulo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.user.role != 1 ? '' : _vm.disabled
    },
    domProps: {
      "value": _vm.development.title
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('title', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": _vm.user.role != 1 ? '' : _vm.disabled,
      "required": ""
    },
    domProps: {
      "value": _vm.development.account_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('account_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), (_vm.user.role == 1) ? _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": _vm.development.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user.role == 1) ? _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.development.date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('date', $event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.development.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.status), function(status) {
    return _c('option', {
      key: status.name,
      domProps: {
        "value": status.name
      }
    }, [_vm._v("\n                " + _vm._s(status.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Observaciones")]), _vm._v(" "), _c('textarea', {
    staticClass: "input w-full border mt-2 flex-1",
    domProps: {
      "value": _vm.development.observations
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('observations', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditDevelopment()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.filteredDevelopments), function(development) {
    return _c('div', {
      key: development.id,
      staticClass: "intro-y col-span-12 sm:col-span-12 md:col-span-12 xxl:col-span-12"
    }, [_c('div', {
      staticClass: "file box rounded-md py-3 px-5 sm:px-8 relative zoom-in flex justify-between"
    }, [_c('div', {
      staticClass: "uppercase my-auto w-1/3"
    }, [_vm._v("\n            " + _vm._s(development.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "my-auto w-48"
    }, [_vm._v("\n            " + _vm._s(development.account.name) + " -\n            " + _vm._s(development.account.country.prefix) + "\n          ")]), _vm._v(" "), ([1].includes(_vm.user.role)) ? _c('div', {
      staticClass: "text-xs my-auto font-bold"
    }, [_vm._v("\n            " + _vm._s(development.hours) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-wrap mt-2 font-bold w-24"
    }, [_c('span', {
      staticClass: "border border-gray-200 p-2 rounded"
    }, [_vm._v("\n              " + _vm._s(development.status) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs my-auto font-bold"
    }, [_vm._v("\n            " + _vm._s(development.observations) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-wrap mt-2"
    }, [_vm._v("\n            " + _vm._s(development.date) + "\n          ")]), _vm._v(" "), ([1, 5].includes(_vm.user.role)) ? _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-4 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editDevelopment(development)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                  Editar\n                ")], 1), _vm._v(" "), ([1].includes(_vm.user.role)) ? _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeDevelopment(development)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                  Eliminar\n                ")], 1) : _vm._e()])])]) : _vm._e()])])
  }), 0)]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "development"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createDevelopment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Titulo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.title),
      expression: "development.title"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.development.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.development, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.account_id),
      expression: "development.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.development, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Horas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.hours),
      expression: "development.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.development.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.development, "hours", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.date),
      expression: "development.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.development.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.development, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Agregar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-757f3c09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/development/ListDevelopments.vue
// module id = 459
// module chunks = 1